import { useEffect, useState } from 'react';

const useProducts = () => {
    const [products, setProducts] = useState([]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_SERVER_API}/products`)
            .then(res => res.json())
            .then(data => setProducts(data))
    }, [products]);

    // return necessary things
    return [products, setProducts];
};

export default useProducts;